import { apiClient } from './client'
import type { ApiResponse } from './client'
import type {
    HubSpotConnectionStatus,
    HubSpotAuthInitiateResult,
    HubSpotMappingConfig,
    HubSpotPipeline,
    HubSpotProperty,
    HubSpotDealAnalytics,
} from '@/types/hubspot'

export const hubspotApi = {
    /** Get the OAuth authorization URL to open in a popup, connecting the company being viewed (ORB-899) */
    initiate: (clientCompanyId: string): Promise<ApiResponse<HubSpotAuthInitiateResult>> =>
        apiClient.get(`/api/ClientCompanies/${clientCompanyId}/Integrations/HubSpot/Initiate`),

    /** Check HubSpot connection status for a company */
    getStatus: (clientCompanyId: string): Promise<ApiResponse<HubSpotConnectionStatus>> =>
        apiClient.get(`/api/ClientCompanies/${clientCompanyId}/Integrations/HubSpot/Status`),

    /** Disconnect HubSpot for a company */
    disconnect: (clientCompanyId: string): Promise<ApiResponse<void>> =>
        apiClient.post(`/api/ClientCompanies/${clientCompanyId}/Integrations/HubSpot/Disconnect`, {}),

    /** Get HubSpot mapping configuration (or defaults if none saved) */
    getConfig: (clientCompanyId: string): Promise<ApiResponse<HubSpotMappingConfig>> =>
        apiClient.get(`/api/ClientCompanies/${clientCompanyId}/Integrations/HubSpot/Config`),

    /** Save HubSpot mapping configuration */
    saveConfig: (clientCompanyId: string, config: HubSpotMappingConfig): Promise<ApiResponse<void>> =>
        apiClient.put(`/api/ClientCompanies/${clientCompanyId}/Integrations/HubSpot/Config`, config),

    /** Get available HubSpot contact properties (for field mapper dropdown) */
    getProperties: (clientCompanyId: string): Promise<ApiResponse<HubSpotProperty[]>> =>
        apiClient.get(`/api/ClientCompanies/${clientCompanyId}/Integrations/HubSpot/Properties`),

    /** Get the portal's deal pipelines (for choosing which count toward the deal figures) */
    getPipelines: (clientCompanyId: string): Promise<ApiResponse<HubSpotPipeline[]>> =>
        apiClient.get(`/api/ClientCompanies/${clientCompanyId}/Integrations/HubSpot/Pipelines`),

    /** Get deal attribution analytics for a workspace (deduped across its campaigns) */
    getWorkspaceDealAnalytics: (workspaceId: string): Promise<ApiResponse<HubSpotDealAnalytics>> =>
        apiClient.get(`/api/Workspaces/${workspaceId}/Integrations/HubSpot/DealAnalytics`),

    /** Get deal attribution analytics for a single campaign (its target-list companies) */
    getCampaignDealAnalytics: (workspaceId: string, campaignId: string): Promise<ApiResponse<HubSpotDealAnalytics>> =>
        apiClient.get(`/api/Workspaces/${workspaceId}/Campaigns/${campaignId}/Integrations/HubSpot/DealAnalytics`),
}
